"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = exports.StyledLink = exports.Title = exports.StyledSection = exports.StyledContainer = exports.Section = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  text-align: ", ";\n  font-size: ", "px;\n  color: ", ";\n  padding: 40px 0;\n  background: ", ";\n  @media ", " {\n    padding: 100px 0;\n  }\n"], ["\n  text-align: ", ";\n  font-size: ", "px;\n  color: ", ";\n  padding: 40px 0;\n  background: ", ";\n  @media ", " {\n    padding: 100px 0;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n"], ["\n  max-width: ", "px;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  padding: 40px 0 !important;\n  background: ", ";\n"], ["\n  padding: 40px 0 !important;\n  background: ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  padding: 10px 15px;\n  margin-right: 10px;\n  display: inline-block;\n  color: ", ";\n  font-size: ", ";\n  transition: all 0.3s ease-in-out;\n  ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  padding: 10px 15px;\n  margin-right: 10px;\n  display: inline-block;\n  color: ", ";\n  font-size: ", ";\n  transition: all 0.3s ease-in-out;\n  ", ";\n  &:hover {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n    text-decoration: none;\n  }\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n          border: 1px solid\n            ", ";\n          background: ", ";\n          border-radius: ", ";\n          color: ", ";\n        "], ["\n          border: 1px solid\n            ", ";\n          background: ", ";\n          border-radius: ", ";\n          color: ", ";\n        "]),
    _templateObject7 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../styles/colors");

var colors = _interopRequireWildcard(_colors);

var _breakpoints = require("../../styles/breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Section = exports.Section = _styledComponents2.default.section(_templateObject, function (props) {
  return props.contentPosition || "center";
}, function (props) {
  return props.contentFontSize || "16";
}, function (props) {
  return props.contentColor || colors.whiteColor;
}, function (props) {
  return props.background ? "url(" + props.background + ") no-repeat center top/cover" : colors.darkBg;
}, _breakpoints2.default.tablet);

var StyledContainer = exports.StyledContainer = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.maxWidth || "700";
});

// Inline content banner

var StyledSection = exports.StyledSection = (0, _styledComponents2.default)(Section)(_templateObject3, function (props) {
  return props.background ? "url(" + props.background + ") no-repeat center top/cover" : colors.darkBg;
});

var Title = exports.Title = _styledComponents2.default.h2(_templateObject4, function (props) {
  return props.headingFontSize || variable.H2;
}, function (props) {
  return props.headingColor || colors.whiteColor;
}, function (props) {
  return props.bottomSpace || "15";
});

var StyledLink = exports.StyledLink = _styledComponents2.default.a(_templateObject5, function (props) {
  return props.contentColor || colors.whiteColor;
}, function (props) {
  return props.buttonFontSize || variable.baseFont;
}, function (props) {
  return props.btnType ? (0, _styledComponents.css)(_templateObject6, function (props) {
    return props.buttonBorderColor || colors.whiteColor;
  }, function (props) {
    return props.buttonBg || {};
  }, function (props) {
    return props.buttonRadius || {};
  }, function (props) {
    return props.buttonColor || colors.whiteColor;
  }) : "";
}, function (props) {
  return props.buttonHoverBg || {};
}, function (props) {
  return props.buttonHoverColor || colors.whiteColor;
}, function (props) {
  return props.hoverBorderColor || {};
});
var Paragraph = exports.Paragraph = _styledComponents2.default.div(_templateObject7, function (props) {
  return props.contentSpace || {};
});